import { useTranslation } from "react-i18next";
import { ElectricIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  openChargeModal: () => void;
};

export default function EstateVehicleChargingStation({ openChargeModal }: Props) {
  const { t } = useTranslation("estate");

  return (
    <div
      className="flex items-center gap-3.5 w-[48.125rem] h-[4.875rem] p-5 rounded-2xl"
      style={{
        background:
          "linear-gradient(90deg, rgba(0, 121, 194, 0.16) 0%, rgba(24, 24, 24, 0.00) 50%), rgba(24, 24, 24, 0.70)",
      }}
    >
      <div className="flex justify-center items-center size-9.5 bg-[#0079C2]/20 rounded-xl">
        <ElectricIcon size={18} className="text-[#1892DC]" />
      </div>
      <div className="flex flex-col gap-[0.1875rem]">
        <p className="text-12 font-bold leading-0 uppercase">
          {t("estate.vehicles.charging.chargingStation")}
        </p>
        <p className="text-14 text-white/50 font-medium leading-0">
          {t("estate.vehicles.charging.info")}
        </p>
      </div>
      <Button
        variant="solid"
        className="min-w-[7.75rem] ml-auto h-9.5 py-2.5 px-4.5 bg-[#0079C2] hover:brightness-110"
        onClick={openChargeModal}
      >
        <ElectricIcon size={12} className="mr-2" /> {t("estate.vehicles.charging.charge")}
      </Button>
    </div>
  );
}
